module.exports = __webpack_public_path__ + "media/Supermarket.6533683f.mp3";